export const MIN_TABLET = 768;
export const MIN_DESKTOP = 1150;
export const DESKTOP_HEADER_HEIGHT = 74;
export const PHONE_HEADER_HEIGHT = 60;
export const SUCCESS_FORM_STATUS_TITLE = 'Заявка отправлена!';
export const ERROR_FORM_STATUS_TITLE = 'Ой, Что-то не так!';
export const SUCCESS_FORM_STATUS_TEXT = 'Теперь осталось немного подождать — в течение нескольких часов мы с вами свяжемся.';
export const ERROR_FORM_STATUS_TEXT = 'Кажется, случился сбой и заявка не прошла. Но вы всегда можете написать нам напрямую!';
export const SUCCESS_SUBSCRIBE_FORM_STATUS_TITLE = 'Подписка оформлена!';
export const SUCCESS_SUBSCRIBE_FORM_STATUS_TEXT = 'Теперь вы будете получать актуальную информацию об учебе за границей.';